class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.addEventListener('mouseleave', this.onMouseLeave.bind(this));

    this.querySelectorAll('details').forEach((details) => {
      if (details === this.mainDetailsToggle) return;

      let subTimeout;
      details.addEventListener('mouseenter', () => {
        if (!window.matchMedia('(min-width: 990px)').matches) return;
        if (subTimeout) clearTimeout(subTimeout);
        details.setAttribute('open', '');
        details.querySelector('summary')?.setAttribute('aria-expanded', 'true');
      });

      details.addEventListener('mouseleave', () => {
        if (!window.matchMedia('(min-width: 990px)').matches) return;
        subTimeout = setTimeout(() => {
          details.removeAttribute('open');
          details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
        }, 150);
      });
    });
  }

  onMouseEnter() {
    if (!window.matchMedia('(min-width: 990px)').matches) return;
    if (this.closeTimeout) clearTimeout(this.closeTimeout);

    document.querySelectorAll('header-menu details[open]').forEach((openDetails) => {
      if (openDetails !== this.mainDetailsToggle && !this.contains(openDetails)) {
        openDetails.removeAttribute('open');
        openDetails.querySelector('summary')?.setAttribute('aria-expanded', 'false');
      }
    });

    this.open();
  }

  onMouseLeave() {
    if (!window.matchMedia('(min-width: 990px)').matches) return;
    this.closeTimeout = setTimeout(() => {
      this.close();
    }, 150);
  }

  open() {
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary')?.setAttribute('aria-expanded', 'true');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
